




















































































































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
import PageSelect from '@/components/page-select/index.vue'
import GoodsApi from '@/api/goods/list/index'
import draggable from 'vuedraggable'
import SearchBar from '../homeSetting/components/searchBar.vue'
import Swiper from '../homeSetting/components/swiper.vue'
import Grid from '../homeSetting/components/grid.vue'
import Video from '../homeSetting/components/video.vue'
import BlankSpace from '../homeSetting/components/blankSpace.vue'
import NoticeBar from '../homeSetting/components/noticeBar.vue'
import Products from '../homeSetting/components/products.vue'
import Pictures from '../homeSetting/components/pictures.vue'
import Coupons from '../homeSetting/components/coupon.vue'
import Activity from '../homeSetting/components/activity.vue'
@Component({
  components: {
    PageSelect,
    draggable,
    SearchBar,
    Swiper,
    Grid,
    Video,
    BlankSpace,
    NoticeBar,
    Products,
    Pictures,
    Coupons,
    Activity
  }
})
export default class CategoriesSetting extends AbpBase {
  activeIndex = 0
  categoryPageList = [
    {
      name: null,
      // 0 指定分类 1 微页面
      isDiyPage: 0,
      contentId: null,
      diyPageName: null
    }
  ]

  ruleCategoryPage = {
    name: [{ required: true, message: '请输入微页面名称', trigger: 'blur' }]
  }

  categoriesList: any = []
  pageinfoList = []
  validateContentId(rule, value, callback) {
    let msg = rule.isDiyPage == 0 ? '请选择指定分类' : '请选择微页面'
    if (!value) {
      return callback(new Error(msg))
    } else {
      callback()
    }
  }

  get activeInfo() {
    return this.categoryPageList[this.activeIndex]
  }

  created() {
    this.getCategoriesAll()
    this.getCategoryPage()
  }

  /**
   * 查询分类页
   */
  getCategoryPage() {
    this.activeIndex = 0
    MallConfig.getCategoryPage().then(res => {
      if (res.data.items && res.data.items.length > 0) {
        res.data.items.forEach(item => {
          item.isDiyPage = item.isDiyPage == true ? 1 : 0
        })

        this.categoryPageList = res.data.items

        this.getPageInfo()
      }
    })
  }

  // 清除分类Id/微页面Id
  clearFn(index) {
    this.categoryPageList[index].contentId = null
    this.categoryPageList[index].diyPageName = null
  }

  menuChange(index) {
    this.activeIndex = index
    this.getPageInfo()
  }
  /**
   * 获取微页面信息
   */
  getPageInfo() {
    this.pageinfoList = []
    if (this.activeInfo.contentId && this.activeInfo.isDiyPage == 1) {
      MallConfig.getMallDiy(this.activeInfo.contentId).then(res => {
        this.pageinfoList = res.data.value.Json.Items
      })
    }
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    let vm = this
    GoodsApi.getCategoriesAll(true).then(res => {
      if (res.data.items) {
        vm.categoriesList = res.data.items.map(child => {
          return {
            value: child.id,
            label: child.fullName
          }
        })
      }
    })
  }

  /**
   * 选择微页面
   */
  selectPageFn(e, index) {
    this.categoryPageList[index].contentId = e.id
    this.categoryPageList[index].diyPageName = e.name
    if (index == this.activeIndex) {
      this.getPageInfo()
    }
  }

  addFn() {
    let obj = {
      name: null,
      // 0 指定分类 1 微页面
      isDiyPage: 0,
      contentId: null,
      diyPageName: null
    }
    this.categoryPageList.push(obj)
  }

  deleteFn(index) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.categoryPageList.splice(index, 1)
        if (index == this.activeIndex) {
          this.activeIndex = 0
          this.getPageInfo()
        }
      }
    })
  }

  /**
   * 保存
   */
  submit() {
    let vm = this
    let isvalid = true
    vm.categoryPageList.forEach((item, index) => {
      let categoryPageForm: any = vm.$refs['categoryPageForm' + index]
      categoryPageForm[0].validate(valid => {
        if (!valid) {
          isvalid = false
        }
      })
    })
    if (isvalid) {
      let list = JSON.parse(JSON.stringify(vm.categoryPageList))
      list.forEach(item => {
        item.isDiyPage = item.isDiyPage == 1 ? true : false
      })
      MallConfig.categoryPage(list).then(res => {
        vm.$Notice.success({
          desc: '提交成功'
        })
        vm.getCategoryPage()
      })
    }
  }
}
